module.exports = __webpack_public_path__ + "img/img3.7fe84860.png";